import { CORE_PHONE_LENGTH } from "common/constants";

export type ParsePhoneInputValueOpts = {
  /**
   * If the extension should be included or not. If the extension should not be included
   * we will never let the user enter more than 10 digits.
   */
  includeExtension?: boolean;
};

/**
 * Removes formatting from phone (any added symbols and spaces)
 * Also handles deleting of a the single last character as a special
 * case to remove the previous symbol.
 *
 * @param previousValue the previous value in the input we are parsing
 * @param currentValue the current (new) value in the input
 * @returns the string representation of the changed phone input
 * */
export const parsePhoneInputValue = (
  previousValue: string,
  currentValue: string,
  { includeExtension = true }: ParsePhoneInputValueOpts = {},
) => {
  const onlyDigits = currentValue.replace(/\D/g, "");
  const nonZeroPrefixedDigits = onlyDigits.replace(/^0+/, "");
  const onlyRelevantDigits = includeExtension
    ? nonZeroPrefixedDigits
    : nonZeroPrefixedDigits.slice(0, CORE_PHONE_LENGTH);

  const isCharacterDelete = currentValue.length === previousValue.length - 1;
  if (!isCharacterDelete) {
    return onlyRelevantDigits;
  }

  const previousLastChar = previousValue.substr(previousValue.length - 1);
  // if the last char was not numeric that means that we should really treat
  // the previous set of values as our working set (the user backspaced to this value)
  // this will functionally allow the user to backspace
  if (previousLastChar < "0" || previousLastChar > "9") {
    return onlyRelevantDigits.slice(0, onlyRelevantDigits.length - 1);
  }
  return onlyRelevantDigits;
};
